import React from 'react'

import { matchAbnormalStatusTagType, abnormalStatusTagText } from '@app/utils'

import { ExternalProductsStatusTagRender } from '@app/components/renderers'

import type { ReactElement } from 'react'
import type { TagStatus, AbnormalState } from '@app/types'
import type { ExternalProduct } from '@app/pages/ProcessingResultsPageInner/types'

export const getAbnormalProductTagStatus = (status?: AbnormalState | null): TagStatus[] => {
  if (!status) return []

  return [
    {
      value: status,
      label: abnormalStatusTagText(status),
      type: matchAbnormalStatusTagType(status)
    }
  ]
}

export const getExternalProductTagStatus = (
  isProductTotalCheck: boolean,
  externalProduct?: ExternalProduct | null
): ReactElement[] => {
  if (!isProductTotalCheck) return []

  const status = externalProduct?.status

  const value = status ?? 'notConfirmed'

  return [
    <ExternalProductsStatusTagRender
      key={ value }
      status={ value }
    />
  ]
}
